var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1426.94 1455.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f8f8f;\n      }\n\n      .cls-2 {\n        fill: #777;\n      }\n\n      .cls-3 {\n        fill: #e7e7e7;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #f0f0f0;\n      }\n\n      .cls-6 {\n        fill: #858585;\n      }\n\n      .cls-7 {\n        fill: #c2c2c2;\n      }\n\n      .cls-8 {\n        fill: #afafaf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -14.04,
    y: 14.04,
    width: 1455.01,
    height: 1426.94,
    transform: "translate(1440.98 14.04) rotate(90)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 67.29,
    y: 76.8,
    width: 1307.88,
    height: 1307.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M964.97,670.26c-38.7,75.1-176.43,68.02-246.18,59.09-69.75,8.93-207.48,16.02-246.18-59.09,0,0-88.53-253.22,11.32-255.28-21.9-94.99,116.28-169.52,112.12-157.86-13.39,37.48-8.6,1.01,108.4-28.17,9.4-2.34,19.29-2.34,28.69,0,117,29.18,121.79,65.65,108.44,28.17-4.16-11.65,133.98,62.87,112.08,157.86,99.85,2.06,11.32,255.28,11.32,255.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545.17,1075.14s164.5-45.98,356.83,0c0,0-20.44,112.02-177.23,151.4,0,0-126.25-16.21-179.6-151.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1375.17,1384.68H67.29c61.97-150.95,227.69-164,408.61-223.25,8.81-2.88,16.8-6.3,24.09-10.29,58.14-31.58,70.7-95.98,82.1-168.77.91-5.68,1.73-11.28,2.47-16.8,10.54-75.27,9.64-133.41,9.64-133.41h254.05s-.99,66.95,12.11,150.2c.78,4.74,1.52,9.43,2.26,14.12,11.12,67.57,25.78,126.28,81.48,155.56,6.84,3.58,14.29,6.71,22.44,9.39,180.96,59.25,346.62,72.3,408.63,223.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1375.17,1384.68H67.29c61.97-150.95,227.69-164,408.61-223.25,8.81-2.88,16.8-6.3,24.09-10.29h.45l224.32,75.39,219.34-74.48c6.84,3.58,14.29,6.71,22.44,9.39,180.96,59.25,346.62,72.3,408.63,223.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M925.84,689.97c14.02-13.55,32.8-27.7,48.56-14.34,15.14,12.83,4.7,35.1-.75,48.01-28.23,66.89-13.35,98.34-31.83,108.33-13.21,7.15-25.57-4.91-34.59-15.81,10.35-40.4,18.97-84.49,18.61-126.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M511.77,689.97c-14.03-13.55-32.8-27.7-48.56-14.34-15.14,12.83-4.7,35.1.75,48.01,28.23,66.89,13.35,98.34,31.83,108.33,13.21,7.15,25.57-4.91,34.59-15.81-10.35-40.4-18.97-84.49-18.61-126.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M862.61,996.47c-28.61,36.68-40.58,48.96-66.01,58.61-37.98,14.41-81.24,15.51-122.13,0-31.53-11.97-42.35-27.95-89.9-89.5,10.51-75.3,9.64-133.43,9.64-133.43h254.03s-.98,66.95,12.12,150.2c.75,4.76,1.5,9.45,2.24,14.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M934.7,754.75c-15.78,86.9-17.78,128.4-56.2,177.91-55.11,70.96-65.26,88.09-98.63,100.79-38,14.41-81.25,15.51-122.14,0-33.37-12.7-43.52-29.83-98.63-100.79-38.42-49.51-40.42-91-56.2-177.91-19.06-105.03-5.21-172.63,9.29-284.12,22.06-170.41,391.2-170.15,413.22,0,14.49,111.49,28.35,179.09,9.29,284.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M754.71,1358.86s4.9,9.72,8.15,25.82h-78.6c3.29-16.1,8.15-25.82,8.15-25.82,0,0-19.85-28.2-31.83-113.31l63-19.02,63,19.02c-11.98,85.11-31.87,113.31-31.87,113.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M946.72,1151.13c-50.93,81.7-149.01,178.62-149.01,178.62-27.46-64.69-75.31-103.21-75.31-103.21,123.73-39.92,179.6-151.4,179.6-151.4,30.88,30.26,44.72,75.99,44.72,75.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M500.46,1151.13c50.93,81.7,149.01,178.62,149.01,178.62,27.46-64.69,75.31-103.21,75.31-103.21-123.73-39.92-179.6-151.4-179.6-151.4-30.88,30.26-44.72,75.99-44.72,75.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M964.97,670.26c-26.76,2.06-36.03,33.97-36.03,33.97,17.54-155.01-7.47-217.3-25.18-241.26-6.48-8.76-18.14-11.83-28.01-7.22-80.5,37.57-232.72,36.42-311.3-.02-9.62-4.46-21.15-1.85-27.54,6.61-17.73,23.48-43.34,85.49-25.65,241.89,0,0-9.26-31.91-36.03-33.97l32.94-267.64c135.87-85.23,92.77-68.89,192.24-79.26,23.62-2.47,14.59-2.59,39.36,0,99.51,10.37,56.37-5.97,192.24,79.26l32.94,267.64Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7a638f50cfce760eb4b8d055eab4d271.svg";
export { ForwardRef as ReactComponent };